export default __webpack_public_path__ + "static/media/asian_college.0b31ea8e.png";